import {
    Component,
    Input,
    Output,
    OnInit,
    OnChanges,
    SimpleChanges,
    EventEmitter
} from '@angular/core';
import {RowsIterator} from "../utils/rows.iterator";

@Component({
    selector: 'filter-tab-content',
    templateUrl: "./filter_tab_content.component.html"
})

export class FilterTabContentComponent implements OnInit, OnChanges {
    @Input()
    public productGroup;

    @Input()
    public products;

    @Input()
    public tabName; // filter name

    @Input()
    public tabIndex;

    @Input()
    public currentTab;

    @Output('onFilterSelected')
    public onFilter: EventEmitter<{type: string, value: any, checked: boolean}>;

    public filters = [];
    public checkedFilters = [];


    public filtersIterator: RowsIterator<Object>;

    constructor() {
        this.onFilter = new EventEmitter<{type: string, value: any, checked: boolean}>();
    }

    ngOnInit(): void {
        this.fillFilters();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (typeof changes.products !== 'undefined' && changes.products.currentValue &&  changes.products.currentValue !==  changes.products.previousValue) {
            this.fillFilters();
        }
    }

    onChecked(event: any){
        let checked =  (typeof this.checkedFilters[event] !== 'undefined') && this.checkedFilters[event];
        this.onFilter.emit({type: this.tabName, value: event, checked: !checked});
        this.checkedFilters[event] = !checked;
    }

    fillFilters() {
        this.filters = [];
        this.products.forEach((product) => {
            product.filters.forEach((filter: {type: string, value: any}) => {
                if(this.tabName.toLowerCase() == filter.type.toLowerCase()){
                    if(this.filters.indexOf(filter.value) == -1) {
                        this.filters.push(filter.value);
                        this.checkedFilters[filter.value] = false;
                    }
                }
            });
        });
        this.filtersIterator = new RowsIterator(this.filters, 3);

    }
    isFilterChecked(filterName){
        let res = (typeof this.checkedFilters[filterName] !== 'undefined') && this.checkedFilters[filterName];
        return res ? "checked": null;
    }

}



// WEBPACK FOOTER //
// ./src/app/filter_panel/filter_tab_content.component.ts